import { UpdateHTMLSpinnerText } from "./UpdateHTMLSpinnerText";
import { updateWaitingExtraLongTime } from "./updateWaitingExtraLongTime";
import { Globals } from "../CoreApp/Globals";

export function updateWaitingLongTime(message) {
  if (!Globals._wsMgr.fWaiting) return;
  UpdateHTMLSpinnerText(message);
  Globals._wsMgr.fWaiting.timeoutmsg = setTimeout(function () {
    updateWaitingExtraLongTime(message);
  }, 15000);
}
